export const fadeVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 1.2 },
};

export const touchVariants = {
  initial: { scale: 1 },
  tap: { scale: 0.95 },
};

export const pageVariants = {
  hidden: { opacity: 0, x: "100vw" },
  visible: { opacity: 1, x: 0, transition: { duration: 0.2, ease: "easeIn" } },
  exit: {
    opacity: 0,
    x: "-100vw",
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

export const backVariants = {
  hiddenBack: { opacity: 0, x: "-100vw" },
  visibleBack: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.2, ease: "easeIn" },
  },
  exitBack: {
    opacity: 0,
    x: "100vw",
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

export const fadeInVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
};

export const pageFadeInVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.2, ease: "easeIn" },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

export const listItemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

export const listItemVariantsX = {
  hidden: { opacity: 0, x: 20 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

export const gradientVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const opacityVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const dailyDarshanChipVariants = {
  hidden: { x: -40 },
  visible: { transition: { duration: 0.2 }, ease: "easeIn", x: 0 },
  exit: { x: 40 },
};

export const slideVariants = {
  initial: { x: "100%", opacity: 1 }, // start off right, invisible
  animate: { x: 0, opacity: 1, transition: { duration: 0.4, ease: "easeInOut" } }, // slide in to center
  exit: { x: "100%", opacity: 0, transition: { duration: 0.4 } }, // slide out to right
};

export const stickyWebHeaderVariants = {
  initial: { opacity: 0, y: -100 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  exit: { opacity: 0, y: -100, transition: { duration: 0.3, ease: "easeIn" } },
};

export const comingFromBottomVariants = {
  initial: { y: 40 },
  animate: { y: 0, transition: { duration: 0.5, ease: "easeInOut" } },
  exit: { y: 20, transition: { duration: 0.3, ease: "easeInOut" } },
};
